export default __webpack_public_path__ + "static/pragicts-ourshare-banner-2-319cfb5ced8e9544915e967e118f1104.jpg";